import * as yup from 'yup'

export const schemaFields = yup.object().shape({
  /*birthdate: yup.date()
  .required('La fecha de nacimiento es obligatoria')
  .nullable()
  .transform((value, originalValue) => (originalValue === '' ? null : value))
  .max(new Date(), 'La fecha no puede ser en el futuro')
  .test('is-adult', 'Debes tener al menos 18 años', value => {
    const today = new Date();
    const eighteenYearsAgo = new Date().setFullYear(today.getFullYear() - 18);
    return new Date(value) <= eighteenYearsAgo;
  }),*/

});